module.exports = __webpack_public_path__ + "static/media/nyselogo200.d827d3a0.png";